import { styled } from "@mui/material/styles";
import { Box, Grid2 } from "@mui/material";

export const RootGrid = styled(Grid2)(({ theme }) => ({
  height: "100vh",
  width: "100vw",
  margin: 0,
  background: theme.palette.background.gradient,
  backgroundColor: theme.palette.background.default,
}));

export const LeftPanel = styled(Grid2)(({ theme }) => ({
  display: "none",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100vh",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

export const LogoImg = styled("img")(({ theme }) => ({
  width: "500px",
  height: "500px",
  maxWidth: "100%",
  maxHeight: "100%",
  aspectRatio: "1",
  objectFit: "contain",
  [theme.breakpoints.up("lg")]: {
    width: "300px",
    height: "300px",
  },
}));

export const RightPanel = styled(Grid2)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    width: "90%",
  },
}));
